import React from "react";
import styled from "styled-components";

const LoginGoogle = styled.button`
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 50px;
  border: none;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
`;

const LoginFacebook = styled.button`
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 50px;
  border: none;
  color: #fffcf2;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  background: #1877f2;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

export { Icon, LoginGoogle, LoginFacebook };
